import agent from 'local/test/agent';

/**
 * Abort current test. The agent will send a testComplete event
 * with task global. To start another test, the client must
 * first send a resetTest event.
 *
 * {@link https://github.com/dotse/bredbandskollen/wiki/Agent-API-v2#instructions-that-the-agent-should-be-able-to-receive}
 */
export default function cancel() {
	agent.send({ method: 'abortTest' });
}
